export default ({
  fetching: {
    isFirstLoading: true,
    getSearchClient: false
  },
  api: {
    dataSource: []
  }
});